import { SelectLand } from '@ts/components/SelectLand';
import { Modal } from '@ts/components/Modal';

export const init = () => {
    setSelectFilters();
    setSupporterModal();
}

const setSelectFilters = () => {
    SelectLand.create('#supporter-sort-filter', {
        prefix: 'Sort by: '
    });
}

const setSupporterModal = () => {
    const supporterTrigger = document.getElementById('');
    Modal.setModalTriggers('.view-supporters', {
        modalTitle: 'Supporters',
        modalSize: 'modal-sm',
        modalTarget: '#view-supporters-modal'
    }); 
}